import clsx from 'clsx'

import { Dashboard } from '../../models/Dashboard'
import Button from '../app/design/Button'
import Label from '../app/design/Label'
import Paragraph from '../app/design/Paragraph'
import { Clickable } from '../common/Clickable'

type Props = {
    dashboard: Dashboard
}

const getMessageDetails = (dashboard: Dashboard) => {
    if (dashboard.id === 'alerts_asap')
        return {
            bg: 'bg-info-100 group-hover:bg-info-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Get setup',
            href: dashboard.title?.includes('finishing')
                ? '/alert/asap?finishing=1'
                : '/alert/asap',
            imageUrl: '/icons/message-card-work-call.svg',
        }
    if (dashboard.id === 'alerts_refer')
        return {
            bg: 'bg-warning-100 group-hover:bg-warning-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Invite',
            href: '/alert/refer',
        }
    if (dashboard.id === 'alerts_affiliate')
        return {
            bg: 'bg-lime-100 group-hover:bg-lime-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Get $50 off',
            href: '/alert/affiliate',
            imageUrl: '/icons/message-card-wallet.svg',
        }
    if (dashboard.id === 'alerts_reader')
        return {
            bg: 'bg-purple-100 group-hover:bg-purple-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Learn more',
            href: '/alert/reader',
            imageUrl: '/icons/message-card-payment.svg',
        }
    if (dashboard.id === 'alerts_team')
        return {
            bg: 'bg-warning-100 group-hover:bg-warning-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Learn more',
            href: '/alert/team',
            imageUrl: '/icons/message-card-boss.svg',
        }
    if (dashboard.id === 'alerts_review')
        return {
            bg: 'bg-lime-100 group-hover:bg-lime-100 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
            button: 'Leave a review',
            href: '/alert/review',
        }
    return {
        bg: 'bg-gray-500 group-hover:bg-gray-500 group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600',
        button: 'Learn more',
        href: '/',
    }
}

export function MessageCard({ dashboard }: Props) {
    const details = getMessageDetails(dashboard)

    return (
        <Clickable
            className={`group m-0 flex gap-0 overflow-x-clip rounded-lg border border-gray-300 p-0`}
            href={details.href}
        >
            <div className="inline h-full grow rounded-lg rounded-r-none p-6 text-wrap">
                <Label size="lg" className="cursor-pointer text-black">
                    {dashboard.title}
                </Label>
                <Paragraph size="sm" className="pt-2 pb-4 text-gray-600">
                    {dashboard.status}
                </Paragraph>
                <Button
                    size="small"
                    intent="secondary"
                    className="group-hover:bg-white group-hover:bg-linear-to-b group-hover:from-black/4 group-hover:to-black/4 group-hover:text-gray-600"
                >
                    {details.button}
                </Button>
            </div>

            <div className={clsx('flex min-w-[120px] justify-center', details.bg)}>
                {details.imageUrl && (
                    <img
                        src={details.imageUrl}
                        alt={dashboard.title}
                        className={clsx('-mr-4 w-28', { 'mr-0': dashboard.id === 'alerts_asap' })}
                    />
                )}
            </div>
        </Clickable>
    )
}
